import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useGlobals, useUserContext } from '@/hooks';

const ProtectedRoute = ({ element, requiredAccess }: any) => {
  // const location = useLocation();
  const { isSignedIn } = useUserContext();
  // const { validateLoginDate } = useTimeMonitorContext();
  // const { connectivityStatus } = useNetworkStatusContext();
  const { canAccessCheckout, canAccessSuccess, setCanAccessCheckout } = useGlobals();

  useEffect(() => {
    if (requiredAccess !== 'checkout' && canAccessCheckout) {
      setCanAccessCheckout(false);
    }
  }, [requiredAccess, canAccessCheckout, setCanAccessCheckout]);

//   useEffect(() => {
//     validateLoginDate();
//   }, [location.pathname, connectivityStatus, validateLoginDate]);

//   useEffect(() => {
//     document.addEventListener('visibilitychange', validateLoginDate);
//     return () => document.removeEventListener('visibilitychange', validateLoginDate);
// }, [validateLoginDate]);
  
  if (!isSignedIn) {
    return <Navigate to="/login" />;
  }

  if (requiredAccess === 'checkout' && !canAccessCheckout) {
    return <Navigate to="/carrinho" replace />;
  }

  if (requiredAccess === 'success' && !canAccessSuccess) {
    return <Navigate to="/checkout" replace />;
  }

  return element;
};

export default ProtectedRoute;
